import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const useClientPagination = ({ elements = [], pageSize = 10 }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [page, setPage] = useState(searchParams.get('page') ? Number(searchParams.get('page')) : 1)

  const elementsPaginated = elements?.slice((page - 1) * pageSize, page * pageSize) || []
  const hasNextPage = page * pageSize < elements?.length
  const hasPreviousPage = page > 1
  const numberOfPages = elements.length ? Math.ceil(elements?.length / pageSize) : 1

  const onChangePage = page => {
    setSearchParams({ page })
    setPage(page)
  }

  return {
    elementsPaginated,
    numberOfPages,
    hasNextPage,
    hasPreviousPage,
    page,
    onChangePage,
  }
}

export default useClientPagination
